import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { LinearSuggestionsGroup } from './LinearSuggestions.Group';
import { LinearSuggestionsItem } from './LinearSuggestions.Item';
import { LinearSuggestionsAdoptableItem } from './LinearSuggestions.AdoptableItem';

export const LinearSuggestionsFallback = () => (
  <LinearSuggestionsGroup heading={<Skeleton className="h-2 w-[40%]" />}>
    {Array.from({ length: 3 })
      .map((_, i) => `example-placeholder${i}`)
      .map((id) => (
        <LinearSuggestionsAdoptableItem className="pl-2" key={id}>
          <Skeleton className="h-2 w-[60%]" />
        </LinearSuggestionsAdoptableItem>
      ))}
    <LinearSuggestionsItem className="pl-2">
      <Skeleton className="h-2 w-[70%]" />
    </LinearSuggestionsItem>
  </LinearSuggestionsGroup>
);
